<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Finalizar Ação de Extensão'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>
                <v-dialog v-model="dialog" width="400">
                  <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>
                      Confirma a finalização da ação?
                    </v-card-title>
                    <v-card-text>

                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-btn color="primary" text @click="dialog = false">Não</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="finalizarAcao()">Sim</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>

                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field readonly label="Título do projeto" :value="this.projeto.titulo"></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs3>
                    <v-text-field readonly label="Número" :value="this.projeto.idProjeto"></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field readonly label="Situação" :value="this.projeto.situacao.descricao"></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <c-date-menu
                      label="Data de finalização"
                      v-model="finalizacao.dataMudancaSituacao"
                      required
                      :rules="regrasBasicas">
                    </c-date-menu>
                  </v-flex>
                </v-layout>

                <p class="mt-3"></p>

                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <c-textarea
                      label="Justificativa/Observação"
                      v-model="finalizacao.justificativaObservacao"
                      :rules="assuntoSummaryRules"
                      :rows="3"
                      :auto-grow="true"
                      multi-line
                      counter="2000"
                     >
                    </c-textarea>
                  </v-flex>
                </v-layout>

                <p class="mt-3"></p>

              </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="dialog = true" :disabled="!formularioValido">Finalizar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import TextArea from '@/components/c-textarea'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      dialog: false,
      formularioValido: false,
      projeto: {
        situacao: {},
        tipoPublico: {},
        classificacoesPrimariaSecundaria: [{}, {}]
      },
      finalizacao: {
        justificativaObservacao: ''
      },
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      assuntoSummaryRules: [
        (input) => input.length <= 2000 || 'Este campo não pode possuir mais que 2000 caracteres'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      cancelar: function () {
        this.$router.go(-1)
      },
      finalizarAcao: function () {
        this.dialog = false
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Finalizando ação de extensão...' })
        projetos.postFinalizarProjeto(this.idProjeto, this.finalizacao)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.go(-1)
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Finalizando ação de extensão...' })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão.' })
      projetos.getProjeto(this.idProjeto)
      .then(response => {
        this.projeto = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando ação de extensão.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu,
      'c-textarea': TextArea
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// finalizar-projeto.vue?313e8d5e